import { Box, RichTextViewer } from '~/commonComponents';

interface IJobDescriptionPreviewProps {
  description: string;
}

export const JobDescriptionPreview = ({ description }: IJobDescriptionPreviewProps) => {
  return (
    <Box gap={14}>
      <RichTextViewer content={description} />
    </Box>
  );
};
